import React, { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const DefaultChannelLogoIcon: FC<TSvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      aria-label="기본채널로고"
      {...props}
    >
      <desc>기본채널로고</desc>
      <path fill="none" d="M0 0h64v64H0z"></path>
      <path
        fill="#c9c9c9"
        d="M32.417 9.812l13.327 5.669v39.517H32.417zM46.292 26.21L58 33.51v21.488H46.292zM31.947 9.812l-17.061 5.669v39.517h17.061zM14.218 33.251l-8.211 2.728V55h8.211z"
      ></path>
      <g fill="#fff">
        <path d="M22.562 16.265l-4.978 1.575v3.884l4.978-1.571zM9.706 36.888l-2.4.758v1.869l2.4-.756zM22.562 21.726l-4.978 1.575v3.884l4.978-1.571zM9.706 39.513l-2.4.758v1.869l2.4-.756zM22.562 26.945l-4.978 1.575v3.884l4.978-1.571zM9.706 42.027l-2.4.758v1.869l2.4-.756zM22.562 32.406l-4.978 1.575v3.884l4.978-1.571zM9.706 44.654l-2.4.758v1.869l2.4-.756zM22.562 37.863l-4.978 1.575v3.884l4.978-1.571zM28.678 14.384L23.7 15.959v3.884l4.978-1.571zM12.649 35.982l-2.4.758v1.869l2.4-.756zM28.678 19.843L23.7 21.418v3.884l4.978-1.571zM12.649 38.611l-2.4.758v1.869l2.4-.756zM28.678 25.064L23.7 26.639v3.884l4.978-1.571zM12.649 41.123l-2.4.758v1.869l2.4-.756zM28.678 30.523L23.7 32.098v3.884l4.978-1.571zM12.649 43.748l-2.4.758v1.869l2.4-.756zM12.649 46.377l-2.4.758v1.869l2.4-.756zM28.678 35.982L23.7 37.557v3.884l4.978-1.571zM48.693 32.291l1.783 1.112v3.272l-1.783-1.087zM48.693 40.943l1.783 1.112v3.272l-1.783-1.087zM48.693 36.558l1.783 1.112v3.272l-1.783-1.087zM51.254 33.998l1.783 1.112v3.272l-1.783-1.087zM51.254 42.65l1.783 1.112v3.272l-1.783-1.087zM51.254 38.267l1.783 1.112v3.272l-1.783-1.087zM53.816 35.705l1.783 1.112v3.272l-1.783-1.087zM53.816 44.359l1.783 1.112v3.272l-1.783-1.087zM53.816 39.974l1.783 1.112v3.272l-1.783-1.087z"></path>
      </g>
    </svg>
  )
}

export default DefaultChannelLogoIcon
